import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "el-tag el-tag--medium fw-bold rounded-none el-tag--info" }
const _hoisted_2 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VatTuDinhMucTable = _resolveComponent("VatTuDinhMucTable")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VatTuDinhMucTable, {
      ref: "vatTuDinhMucTableRef",
      "id-dinh-muc": _ctx.selectingDinhMuc?.id,
      "show-don-gia": false,
      onOnClose: _ctx.onCloseModal
    }, null, 8, ["id-dinh-muc", "onOnClose"]),
    _createVNode(_component_PageContentSection, { "always-expanded": true }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.dinhMucTotalDisplay), 1)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_ButtonCustom, {
          classes: `rounded-none m-0`,
          "button-type": _ctx.ButtonsType.ADD,
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
					_ctx.push({
						name: 'tao-moi-dinh-muc-co-dinh',
						query: {
							'id-danh-muc-toa-xe': _ctx.danhMucToaXeId,
						},
					})
				))
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode(" Thêm ĐMCĐ ")
          ]),
          _: 1
        }, 8, ["button-type", "color-type"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          size: "medium",
          "empty-text": "Chưa có vật tư nào trong định mức",
          border: true,
          data: _ctx.dinhMucCoDinhItems
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "STT",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.$index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "ID",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Cấp sửa chữa" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.cap_sua_chua?.ten_cap_sc || scope.row.id_cap_sc), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Ngày ban hành",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.formatDisplayingDate(scope.row.ngay_ban_hanh) || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Ngày hết hạn",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["el-tag el-tag--medium fw-bold rounded-none d-block w-100", _ctx.ngayHetHanBadgeClass(scope.row)])
                }, _toDisplayString(scope.row.ngay_het_han
									? _ctx.formatDisplayingDate(scope.row.ngay_het_han)
									: 'Chưa xác định'), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Mô tả" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.mo_ta || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Trạng thái",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["el-tag el-tag--medium fw-bold rounded-none", _ctx.statusBadgeClass(_ctx.getDinhMucStatus(scope.row))])
                }, _toDisplayString(_ctx.statusLabel(_ctx.getDinhMucStatus(scope.row))), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { width: "120" }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ButtonCustom, {
                    classes: `rounded-none m-0`,
                    "button-type": _ctx.ButtonsType.INFO,
                    "color-type": 
									(scope.row.vat_tu?.length ?? 0) > 0
										? _ctx.ButtonTypeColors.SUCCESS
										: _ctx.ButtonTypeColors.DANGER
								,
                    onClick: ($event: any) => (_ctx.onDetailButtonClicked(scope.$index))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.vat_tu?.length ?? 0) + " v/tư ", 1)
                    ]),
                    _: 2
                  }, 1032, ["button-type", "color-type", "onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    })
  ], 64))
}